<template>
    <div>
        <el-row>
            <el-col :span="18">
                <el-button v-if="currentMenuOperations.some(func => func.name.includes('role_add'))" type="primary" @click="add" icon="el-icon-plus">新增角色</el-button>
            </el-col>
            <el-col :span="6">
                <el-input v-model="search" placeholder="搜索" @change="getDatas">
                    <el-button slot="append" icon="el-icon-search" @click="getDatas"></el-button>
                </el-input>
            </el-col>
        </el-row>
    <el-table
      :data="tables"
      :default-sort="{prop: 'id', order: 'descending'}"
      tooltip-effect="light"
      style="width: 100%"
    >
      <el-table-column align="center" prop="name" label="名称"></el-table-column>
      <el-table-column align="center" prop="area" label="描述"></el-table-column>
      <el-table-column align="center" prop="room" label="创建时间">
          <template slot-scope="scope">
              {{new Date(scope.row.createTime).Format('yyyy/MM/dd hh:mm:ss')}}
          </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200px;" v-if="listOperations.length > 0">
        <template slot-scope="scope">
          <el-button v-if="listOperations.some(func => func.name.includes('edit'))"
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="role_edit(scope.row)"
          >编辑</el-button>

          <el-button v-if="listOperations.some(func => func.name.includes('del'))"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="role_del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
        <el-pagination
            class="fy"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElement"
        ></el-pagination>

        <el-dialog v-if="showAddDialog"
            title="角色信息"
            :visible="showAddDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="roleAddCallback(false)"
            width="80%"
            >
            <role-add :roleId="currentMenuId" @roleAddCallback="roleAddCallback"/>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { Loading } from "element-ui"
import RoleAdd from './RoleAdd'
export default {
    components: { RoleAdd },
    data: vm=>({
        tables: [], //列表数据
        search: null, //搜索关键字
        currentPage: 1,
        pageSize: 10,
        showAddDialog: false,
        currentMenuId: null,
        totalElement: 0,
    }),
    computed: {
        ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
        // totalElement(){
        //     return this.tables.length
        // }
    },
    created(){
        this.getListOperations('role');
        if(!this.currentMenu){
            return
        }
        this.getDatas()
    },
    methods: {
        ...mapMutations(['getListOperations']),
        getDatas(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
                .get(this.baseUrl3 + "role/findByPageLike/"
                    + this.currentPage + "/"
                    + this.pageSize + '/'
                    + this.search)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.tables = data.list
                        this.totalElement = data.total
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        add(){
            this.showAddDialog = true
        },
        role_edit(row){
            this.currentMenuId = row.id
            this.showAddDialog = true
        },
        del(row){
            this.$axios
                .get(this.baseUrl3 + "role/del/" + row.id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.$message.success('操作成功')
                        this.getDatas()
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(error => {
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        role_del(row){
            this.$confirm('您确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(row)
            }).catch(() => {

            });
        },
        handleSizeChange(val){
            this.pageSize = val
            this.getDatas()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.getDatas()
        },
        roleAddCallback(val){
            this.showAddDialog = false
            this.currentMenuId = null
            if(val){
                this.getDatas()
            }
        }
    }
}
</script>
